module.exports = __webpack_public_path__ + "files/f88c84dbbe121e159b05146eee0af29d.svg";